import { Injectable } from "@angular/core";
import { DynamicFormService, DynamicFormControlModel, DynamicInputModel } from '@ng-dynamic-forms/core';
import { Model_WorkflowComponent, CODE_WORKFLOW_COMPONENT, TYPE_DATASOURCE, TYPE_WORKFLOW_COMPONENT_OBSERVER, TYPE_DEFAULT_VALUE, Model_Workflow, Model_VariableEnvironnementUser, Model_Datasource, Expression, EXPRESSION_FIELD_SCOPE, TYPE_COMPONENT_CONDITIONS, WorkflowComponentObserver, AbsDSOptionsItems, FONCTION_WORKFLOW_COMPONENT, TYPE_VARIABLE_ENVIRONMENT } from 'src/app/app.models';
import { TextboxModel } from './textbox/textbox.model';
import { DropdownModel } from './dropdown/dropdown.model';
import { TextareaModel } from './textarea/textarea.model';
import { DatasourcePickerModel, Model_WorkflowDatasourcePickerComponent } from './datasource-picker/datasource-picker.model';
import { BehaviorSubject, of, Observable, Subject } from 'rxjs';
import { CheckboxModel } from './checkbox/checkbox.model';
import { DocumentScannerModel } from './document-scanner/document-scanner.model';
import { CameraModel } from './camera/camera.model';
import { COMPONENT_MODE } from './workflow-components.models';
import { NumericTextboxModel } from './numeric-textbox/numeric-textbox.model';
import { ToggleModel } from './toggle/toggle.model';
import { DatePickerModel } from './datepicker/datepicker.model';
import { RadioboxModel } from './radiobox/radiobox.model';
import { UploadFileModel } from './upload-file/upload-file.model';
import { InputGridModel } from './input-grid/input-grid.model';
import { FamocoScanLaserModel } from './famoco-scan-laser/famoco-scan-laser.model';
import { CodeScannerModel } from './code-scanner/code-scanner.model';
import { ElectronicSignatureModel } from './electronic-signature/electronic-signature.model';
import { InputGridColumnsBuilderModel, Model_InputGridColumnsBuilderComponent } from './input-grid/input-grid-columns-builder/input-grid-columns-builder.model';
import {v4 as uuidv4} from 'uuid';
import * as mathjs from 'mathjs'
import { RichAutocompleteModel, Model_WorkflowRichAutoCompleteComponent } from './rich-autocomplete/rich-autocomplete.model';
import * as moment from 'moment';
import { DatasourceService } from 'src/app/core-api/services/datasource/datasource.service';
import { AuthService } from 'src/app/core-api/services/auth/auth.service';
import { Guid } from 'guid-typescript';
import { GedDesignerModel } from './ged-designer/ged-designer.model';
import { GedModel } from './ged/ged.model';
import { BarcodesVerificationModel } from './@soudotec/barcodes-verification/barcodes-verification.model';
import { CommandGridInputModel } from './@soudotec/command-gridinput/command-gridinput.model';
import { InventoryInputModel } from './@soudotec/inventory-input/inventory-input.model';
import { InputGridColumnsDatasourceMappingModel } from './input-grid/input-grid-columns-datasource-mapping/input-grid-columns-datasource-mapping.model';
import { MibemCommandInputModel } from './@mibem/mibem-command-input/mibem-command-input.model';
import { ExpressionEvaluatorModel } from './expression-evaluator/expression-evaluator.model';
import { DatasourceDatasSelectionModel } from './datasource-datas-selection/datasource-datas-selection.model';
import { InputGridFunctionsModel } from './input-grid-functions/input-grid-functions.model';
import { LabelModel } from './label/label.model';
import { InputGridFunctionsFiltersModel } from './input-grid-functions/input-grid-functions-filters/input-grid-functions-filters.model';
import { ApplyFilterDatasource } from './datasource-picker/datasource.helper';
import { ReceptionMarchandiseModel } from './@soudotec/reception-marchandise/reception-marchandise.model';
import { NewlandScannerModel } from './newland-scanner/newland-scanner.model';
import { BERetailInventoryInputModel } from './@be_retail/inventory-input/be-retail-inventory-input.model';
import { AgendaPlannerModel } from './@blackhawk/agenda-planner/agenda-planner.model';
import { BHQrCodeSiteScannerModel } from './@blackhawk/bh-qrcode-site-scanner/bh-qrcode-site-scanner.model';
import { BHQrCodeScannerModel } from './@blackhawk/bh-qrcode-scanner/bh-qrcode-scanner.model';
import { MultipackCommercialPlanningModel } from "./@multipack/commercial-planning/commercial-planning.model";
import { KanbanModel } from "./kanban/kanban.model";
import { SoudotecItemsInputModel } from "./@soudotec/items-input/soudotec-items-input.model";
import { SoudotecEmplacementInputModel } from "./@soudotec/emplacement-input/soudotec-emplacement-input.model";

export class WorkflowComponentBuilderOptions {
    COMPONENTS_MODE: COMPONENT_MODE;
    responseWorkflowLocalId?: string;
    workflow?: Model_Workflow;
    variablesEnvironnement?: any[];
    formId?: string;

    gridFormId?: string;
    isGridComponent?: boolean;
}

export class EventWorkflowValuesChanged {
    formModels?: {[key: string]: DynamicFormControlModel[]};
    formValues?: {[key: string]: any}; 
    sender?: { ID: string, value: any, FORM_ID?: string, PARENT_GRID_INPUT_ID?: string };
    workflow?: Model_Workflow;
    callersStack?: string[];
}

@Injectable({
    providedIn: 'root'
})
export class WorkflowComponentsService {
    context = new EventWorkflowValuesChanged();
    workflowValuesChanged$ = new Subject<EventWorkflowValuesChanged>();
    workflowDesignerComponentSelected$ = new BehaviorSubject<Model_WorkflowComponent>(null);
    gridComponentsValuesChanged$ = new BehaviorSubject<any>(null);
    
    constructor(
        public formService: DynamicFormService,
        private _datasourceService: DatasourceService,
        private _authService: AuthService
    ) {
        this.workflowValuesChanged$.subscribe(context => this.context = context);
    }

    // #region PROCESS COMPONENT
    private async _doBuildComponentDatasource(_component: Model_WorkflowComponent, _options: WorkflowComponentBuilderOptions, _datasourceInfos: any) {
        let datasourceObject = { 
            datasource: { TYPE_DATASOURCE: TYPE_DATASOURCE.STATIC }, 
            datas: [], 
            filteredDatas: [],
            DATASOURCE_VALUE_FIELD: 'ID', 
            DATASOURCE_DISPLAY_FIELD: 'TEXT',
            DATASOURCE_DS_FILTERS: [],
            absColumns: [],
            countTotal: 0,
            pageNumber: 1,
            totalPages: 1,
            pageSize: 0
        };
        //if (_component.HAS_DATASOURCE === true && !!_component.NUM_DATASOURCE && !!_component.NUM_DATASOURCE.NUM_DATASOURCE) {
            try {
                if (!!_component[_datasourceInfos.DS_PROP_ID] && !!_component[_datasourceInfos.DS_PROP_ID].DS_PARAMETERS) {
                    _component[_datasourceInfos.DS_PROP_ID].DS_PARAMETERS.forEach((dsParam, index, dsParameters) => {
                        if (dsParam.TYPE_DEFAULT_VALUE == TYPE_DEFAULT_VALUE.ENVIRONMENT_VARIABLE && !!_options.variablesEnvironnement) {
                            const variablesUser = this._authService.envVariables$.value;
                            const matchedVariable = variablesUser.find(c => c.NOM_VARIABLE == dsParam.DEFAULT_VALUE);
                            if (!!matchedVariable) {
                                dsParameters[index].DEFAULT_VALUE = matchedVariable.VALEUR_VARIABLE;
                            }
                        } else if (dsParam.TYPE_DEFAULT_VALUE == TYPE_DEFAULT_VALUE.WORKFLOW_FIELD)  {
                            const gridContext = this.context;
                            if (!!gridContext && !!gridContext.formValues) {
                                if (_options.isGridComponent !== undefined && _options.isGridComponent === true && !!_options.gridFormId && !!gridContext.formValues[_options.gridFormId]) {
                                    const gridFormValues = gridContext.formValues[_options.gridFormId];
                                    if (!!gridFormValues && !!gridFormValues[dsParam.DEFAULT_VALUE]) {
                                        const filterValue = gridFormValues[dsParam.DEFAULT_VALUE];
                                        dsParameters[index].DEFAULT_VALUE = filterValue;
                                    }
                                } else if (!!_options.formId && !!gridContext.formValues[_options.formId]) {
                                    const gridFormValues = gridContext.formValues[_options.formId];
                                    if (!!gridFormValues && !!gridFormValues[dsParam.DEFAULT_VALUE]) {
                                        const filterValue = gridFormValues[dsParam.DEFAULT_VALUE];
                                        dsParameters[index].DEFAULT_VALUE = filterValue;
                                    }
                                }
                            }
                        } else if (dsParam.TYPE_DEFAULT_VALUE == TYPE_DEFAULT_VALUE.WORKFLOW_GRID_FIELD)  {
                            const gridContext = this.context;
                            if (!!gridContext && !!gridContext.formValues) {
                                if (_options.isGridComponent !== undefined && _options.isGridComponent === true && !!_options.formId && !!gridContext.formValues[_options.formId]) {
                                    const gridFormValues = gridContext.formValues[_options.formId];
                                    if (!!gridFormValues && !!gridFormValues[dsParam.DEFAULT_VALUE]) {
                                        const filterValue = gridFormValues[dsParam.DEFAULT_VALUE];
                                        dsParameters[index].DEFAULT_VALUE = filterValue;
                                    }
                                } else if (!!_options.formId && !!gridContext.formValues[_options.formId]) {
                                    const gridFormValues = gridContext.formValues[_options.formId];
                                    if (!!gridFormValues && !!gridFormValues[dsParam.DEFAULT_VALUE]) {
                                        const filterValue = gridFormValues[dsParam.DEFAULT_VALUE];
                                        dsParameters[index].DEFAULT_VALUE = filterValue;
                                    }
                                }
                            }
                        }
                    });
                }
                if (!!_component[_datasourceInfos.DS_PROP_ID]) {
                    const datasource = await this._datasourceService.doLoadDatasource(_component[_datasourceInfos.DS_PROP_ID]);
                    datasourceObject.datasource = datasource;
                    if (datasource.TYPE_DATASOURCE == TYPE_DATASOURCE.JSON) {
                        datasourceObject.datas = datasource.datas.mRawDatas;
                    } else {
                        datasourceObject.absColumns = datasource.datas.mAbsColumns;
                        datasourceObject.datas = datasource.datas.mPagination.mDatas;
                        datasourceObject.filteredDatas = datasource.datas.mPagination.mDatas;
                        datasourceObject.countTotal = datasource.datas.mPagination.mCountTotal;
                        datasourceObject.pageNumber = datasource.datas.mPagination.mPageNumber;
                        datasourceObject.totalPages = datasource.datas.mPagination.mTotalPages;
                        datasourceObject.pageSize = datasource.datas.mPagination.mPageSize;
                        if (!!_component[_datasourceInfos.DS_PROP_ID].DS_FILTERS) {
                            datasourceObject.filteredDatas = datasourceObject.datas;
                            _component[_datasourceInfos.DS_PROP_ID].DS_FILTERS.forEach(_filter => {
                                if (_filter.TYPE_DEFAULT_VALUE == TYPE_DEFAULT_VALUE.CONSTANT) {
                                    datasourceObject.filteredDatas = datasourceObject.filteredDatas.filter(d => ApplyFilterDatasource(_filter, _filter.DEFAULT_VALUE, d)); 
                                } else if (_filter.TYPE_DEFAULT_VALUE == TYPE_DEFAULT_VALUE.ENVIRONMENT_VARIABLE && !!_options.variablesEnvironnement) {
                                    const variablesUser = this._authService.envVariables$.value;
                                    const matchedVariable = variablesUser.find(c => c.NOM_VARIABLE == _filter.DEFAULT_VALUE);
                                    if (!!matchedVariable) {
                                        datasourceObject.filteredDatas = datasourceObject.filteredDatas.filter(d => ApplyFilterDatasource(_filter, matchedVariable.VALEUR_VARIABLE, d)); 
                                    }
                                } else if (_filter.TYPE_DEFAULT_VALUE == TYPE_DEFAULT_VALUE.WORKFLOW_FIELD)  {
                                    const gridContext = this.context;
                                    if (!!gridContext && !!gridContext.formValues) {
                                        if (_options.isGridComponent !== undefined && _options.isGridComponent === true && !!_options.gridFormId && !!gridContext.formValues[_options.gridFormId]) {
                                            const gridFormValues = gridContext.formValues[_options.gridFormId];
                                            if (!!gridFormValues && !!gridFormValues[_filter.DEFAULT_VALUE]) {
                                                const filterValue = gridFormValues[_filter.DEFAULT_VALUE];
                                                datasourceObject.filteredDatas = datasourceObject.filteredDatas.filter(d => ApplyFilterDatasource(_filter, filterValue, d)); 
                                            }
                                        } else if (!!_options.formId && !!gridContext.formValues[_options.formId]) {
                                            const gridFormValues = gridContext.formValues[_options.formId];
                                            if (!!gridFormValues && !!gridFormValues[_filter.DEFAULT_VALUE]) {
                                                const filterValue = gridFormValues[_filter.DEFAULT_VALUE];
                                                datasourceObject.filteredDatas = datasourceObject.filteredDatas.filter(d => ApplyFilterDatasource(_filter, filterValue, d)); 
                                            }
                                        }
                                    }
                                } else if (_filter.TYPE_DEFAULT_VALUE == TYPE_DEFAULT_VALUE.WORKFLOW_GRID_FIELD)  {

                                    const gridContext = this.context;
                                    if (!!gridContext && !!gridContext.formValues) {
                                        if (_options.isGridComponent !== undefined && _options.isGridComponent === true && !!_options.formId && !!gridContext.formValues[_options.formId]) {
                                            const gridFormValues = gridContext.formValues[_options.formId];
                                            if (!!gridFormValues && !!gridFormValues[_filter.DEFAULT_VALUE]) {
                                                const filterValue = gridFormValues[_filter.DEFAULT_VALUE];
                                                datasourceObject.filteredDatas = datasourceObject.filteredDatas.filter(d => ApplyFilterDatasource(_filter, filterValue, d)); 
                                            }
                                        } else if (!!_options.formId && !!gridContext.formValues[_options.formId]) {
                                            const gridFormValues = gridContext.formValues[_options.formId];
                                            if (!!gridFormValues && !!gridFormValues[_filter.DEFAULT_VALUE]) {
                                                const filterValue = gridFormValues[_filter.DEFAULT_VALUE];
                                                datasourceObject.filteredDatas = datasourceObject.filteredDatas.filter(d => ApplyFilterDatasource(_filter, filterValue, d)); 
                                            }
                                        }
                                    }
                                }
                            });
                        }
                        datasourceObject.DATASOURCE_VALUE_FIELD = _component[_datasourceInfos.DS_PROP_VALUE_COLUMN_ID] || _component.VALUE_COLUMN_NAME;
                        datasourceObject.DATASOURCE_DISPLAY_FIELD = _component[_datasourceInfos.DS_PROP_DISPLAY_COLUMN_ID] || _component.DISPLAY_COLUMN_NAME;
                        datasourceObject.DATASOURCE_DS_FILTERS = _component[_datasourceInfos.DS_PROP_ID].DS_FILTERS || [];
                    }
                }
            } catch(e) {
                console.error(e);
            }
        //}

        return datasourceObject;
    }

    private _getRelatedComponents(_component: Model_WorkflowComponent, _listComponents: Model_WorkflowComponent[]): Model_WorkflowComponent[] {
        let regex = /\@\[([\w]+)\]/g;
        let relatedComponents: Model_WorkflowComponent[] = [];
        if (!!_component.TYPE_DEFAULT_VALUE && _component.TYPE_DEFAULT_VALUE == TYPE_DEFAULT_VALUE.COMPUTED) {
            const expression = _component.DEFAULT_VALUE_EXPRESSION;
            let computedControls = expression.match(regex);
            if (!!computedControls) {
                computedControls.map(matched => matched.substr(2, matched.length - 3)).forEach((field) => {
                    const matchedComponent = _listComponents.find(c => c.ID == field && c.ID != _component.ID);
                    let subRelatedComponents = [matchedComponent];
                    if (!!matchedComponent) {
                        if (matchedComponent.TYPE_DEFAULT_VALUE == TYPE_DEFAULT_VALUE.COMPUTED) {
                            subRelatedComponents = subRelatedComponents.concat(this._getRelatedComponents(matchedComponent, _listComponents));
                        } else if (matchedComponent.TYPE_DEFAULT_VALUE == TYPE_DEFAULT_VALUE.WORKFLOW_FIELD) {
                            const relatedComponent = _listComponents.find(c => c.ID == matchedComponent.DEFAULT_VALUE_WORKFLOW_COMPONENT_ID);
                            if (!!relatedComponent) {
                                subRelatedComponents.push(relatedComponent);
                            }
                        }
                        relatedComponents = relatedComponents.concat(subRelatedComponents.filter(c => relatedComponents.findIndex(b => b.ID == c.ID) == -1));
                    }
                });
            }
        }

        return relatedComponents;
    }

    private _getFullExpression(_component: Model_WorkflowComponent, _listComponents: Model_WorkflowComponent[]) {
        let regex = /\@\[([\w]+)\]/g;
        let expression = _component.DEFAULT_VALUE_EXPRESSION;
        if (!!expression) {
            let computedControls = expression.match(regex);
            if (!!computedControls && computedControls.length > 0) {
                computedControls.map(matched => matched.substr(2, matched.length - 3)).forEach((field) => {
                    const matchedComponent = _listComponents.find(c => c.ID == field && c.ID != _component.ID);
                    if (!!matchedComponent && matchedComponent.TYPE_DEFAULT_VALUE == TYPE_DEFAULT_VALUE.COMPUTED) {
                        const subExpression = this._getFullExpression(matchedComponent, _listComponents);
                        expression = expression.replace(new RegExp('\\@\\[' + field + '\\]', 'g'), subExpression);
                    }
                });
            }
        }
        return expression;
    }

    private _processComponentDefaultValue(_component: Model_WorkflowComponent, _options: WorkflowComponentBuilderOptions) {
        const typeDefaultValue = _component.TYPE_DEFAULT_VALUE;
        let defaultValue = _component.DEFAULT_VALUE;
        const workflowComponents = !!_options && !!_options.workflow ? Array.prototype.concat.apply([], _options.workflow.WORKFLOW_STEPS.filter(step => !!step.COMPONENTS).map(step => step.COMPONENTS/*.map(component => ({ ID: component.ID, TEXT: `${component.INDEX} - ${component.LABEL} [${component.CODE}]`, NUMWORKFLOW_STEP: step.NUM_WORKFLOWSTEP }))*/)) : [];
        const context = this.context;
        const session = this._authService.AuthSession;
        const variablesUser = this._authService.envVariables$.value;
        const formId = _component.FORM_ID || '_FORM_';
        let result: any = '';

        if (!_component.UIC_PARAMS) {  _component.UIC_PARAMS = {}; }
        if (!_component.UIC_PARAMS.OBSERVERS) { _component.UIC_PARAMS.OBSERVERS = []; }

        switch(typeDefaultValue) {
            case TYPE_DEFAULT_VALUE.COMPUTED: 
                let expression = this._getFullExpression(_component, workflowComponents);
                if (!!expression) {
                    const relatedComponents = this._getRelatedComponents(_component, workflowComponents);
                    /*if (relatedComponents.length > 0) {
                        relatedComponents.forEach(relatedComponent => {
                            _component.UIC_PARAMS.OBSERVERS.push({ field: relatedComponent.ID, type: TYPE_WORKFLOW_COMPONENT_OBSERVER.OBSERVER_VALUE, params: expression, formId: _options.formId });

                            if ( !!context.formValues && !!context.formValues[formId] && !!context.formValues[formId][relatedComponent.ID]) {
                                var fieldValue = context.formValues[formId][relatedComponent.ID];
                                if (isNaN(fieldValue)) {
                                    fieldValue = 0;
                                }
                                expression = expression.replace(new RegExp('\\@\\[' + relatedComponent.ID + '\\]', 'g'), fieldValue);
                            }
                        });
                    /*} else {*/
                        let regex = /\@\[([\w]+)\]/g;
                        const relatedComponentsIds = expression.match(regex);
                        if (_options.COMPONENTS_MODE == COMPONENT_MODE.EXECUTION && !!relatedComponentsIds && relatedComponentsIds.length > 0) {
                            relatedComponentsIds.map(matched => matched.substr(2, matched.length - 3)).forEach(relatedComponentId => {
                                _component.UIC_PARAMS.OBSERVERS.push({ field: relatedComponentId, type: TYPE_WORKFLOW_COMPONENT_OBSERVER.OBSERVER_VALUE, params: expression, formId: _options.isGridComponent == true && !!_options.gridFormId ? _options.gridFormId : _options.formId });
                            });
                        }
                    /*}
                    const */regex = /\#\[([\w]+)\]/g;
                    const computedVariablesIds = expression.match(regex);
                    if (!!computedVariablesIds && computedVariablesIds.length > 0) {
                        computedVariablesIds.map(matched => matched.substr(2, matched.length - 3)).forEach((match) => {
                            const matchedVariable = variablesUser.find(c => c.NOM_VARIABLE == match);
                            if (!!matchedVariable) {
                                var fieldValue = parseFloat(matchedVariable.VALEUR_VARIABLE);
                                if (isNaN(fieldValue)) {
                                    fieldValue = 0;
                                }
                                expression = expression.replace(new RegExp('\\#\\[' + match + '\\]', 'g'), fieldValue.toString());
                            }
                        });
                    }
                    try {
                        result = mathjs.evaluate(expression);
                    } catch(e) {}
                }
                defaultValue = _component.RESPONSE_VALUE || result;
                break;

            case TYPE_DEFAULT_VALUE.ENVIRONMENT_VARIABLE: 
                defaultValue = _component.RESPONSE_VALUE || _component.DEFAULT_VALUE;
                if (_options.COMPONENTS_MODE == COMPONENT_MODE.EXECUTION) {
                    const variable = variablesUser.find(v => v.NOM_VARIABLE == _component.DEFAULT_VALUE);
                    if (!!variable) {
                        defaultValue = variable.VALEUR_VARIABLE;
                        if (!defaultValue && variable.VARIABLE_ENVIRONNEMENT.TYPE_VARIABLE == TYPE_VARIABLE_ENVIRONMENT.NUMBER) {
                            defaultValue = 0;
                        }
                    }
                }
                break;

            case TYPE_DEFAULT_VALUE.WORKFLOW_FIELD: 
                defaultValue = _component.RESPONSE_VALUE || _component.DEFAULT_VALUE;
            
                if (_options.COMPONENTS_MODE == COMPONENT_MODE.EXECUTION) {
                    _component.UIC_PARAMS.OBSERVERS.push({ field: _component.DEFAULT_VALUE_WORKFLOW_COMPONENT_ID, type: TYPE_WORKFLOW_COMPONENT_OBSERVER.OBSERVER_VALUE, params: { DS_PROPERTY: _component.DEFAULT_VALUE_WORKFLOW_COMPONENT_PROPERTY }, formId: _options.isGridComponent == true && !!_options.gridFormId ? _options.gridFormId : _options.formId });
                    const contextformId = _options.gridFormId || _options.formId;
                    if (!!context.formValues && !!context.formValues[contextformId] && !!context.formValues[contextformId][_component.DEFAULT_VALUE_WORKFLOW_COMPONENT_ID]) {
                        if (!!_component.DEFAULT_VALUE_WORKFLOW_COMPONENT_ID && !!_component.DEFAULT_VALUE_WORKFLOW_COMPONENT_PROPERTY && !!context.formModels && !!context.formModels[contextformId]) {
                            const formModel: any = context.formModels[contextformId].find(model => model.id == _component.DEFAULT_VALUE_WORKFLOW_COMPONENT_ID);
                            if (!!formModel && !!formModel.datas) {
                                const selectedValue = formModel.datas.find(d => d[formModel.valueField] == formModel.value);
                                if (selectedValue !== undefined && !!selectedValue[_component.DEFAULT_VALUE_WORKFLOW_COMPONENT_PROPERTY]) {
                                    defaultValue = selectedValue[_component.DEFAULT_VALUE_WORKFLOW_COMPONENT_PROPERTY];
                                }
                            }
                        } else {
                            defaultValue = context.formValues[contextformId][_component.DEFAULT_VALUE_WORKFLOW_COMPONENT_ID];
                        }
                    }
                }
                break;

            case TYPE_DEFAULT_VALUE.WORKFLOW_GRID_FIELD: 
                defaultValue = _component.RESPONSE_VALUE || _component.DEFAULT_VALUE;

                if (_options.COMPONENTS_MODE == COMPONENT_MODE.EXECUTION) {
                    _component.UIC_PARAMS.OBSERVERS.push({ field: _component.DEFAULT_VALUE_WORKFLOW_COMPONENT_ID, type: TYPE_WORKFLOW_COMPONENT_OBSERVER.OBSERVER_GRID_VALUE, params: { DS_PROPERTY: _component.DEFAULT_VALUE_WORKFLOW_COMPONENT_PROPERTY }, formId: _options.isGridComponent == true && !!_options.gridFormId ? _options.gridFormId : _options.formId });
                    if (!!context.formValues && !!context.formValues[_options.gridFormId] && !!context.formValues[_options.gridFormId][_component.DEFAULT_VALUE_WORKFLOW_COMPONENT_ID]) {
                        defaultValue = context.formValues[_options.gridFormId][_component.DEFAULT_VALUE_WORKFLOW_COMPONENT_ID];
                    }
                }
                break;

            case TYPE_DEFAULT_VALUE.FONCTION:
                if (_options.COMPONENTS_MODE == COMPONENT_MODE.CONSULTATION) {
                    defaultValue = _component.RESPONSE_VALUE || _component.DEFAULT_VALUE || result;
                } else if (!!_component.TYPE_DEFAULT_VALUE_FUNCTION_ID) {
                    switch(_component.TYPE_DEFAULT_VALUE_FUNCTION_ID) {
                        case FONCTION_WORKFLOW_COMPONENT.ID_AGENT:
                            defaultValue = session.User.ID;
                            break;
                        case FONCTION_WORKFLOW_COMPONENT.NOM_AGENT:
                            defaultValue = session.User.NOM;
                            break;
                        case FONCTION_WORKFLOW_COMPONENT.PRENOMS_AGENT:
                            defaultValue = session.User.PRENOM;
                            break;
                        case FONCTION_WORKFLOW_COMPONENT.USERNAME_AGENT:
                            defaultValue = session.User.USERNAME;
                            break;
                        case FONCTION_WORKFLOW_COMPONENT.EMAIL_AGENT:
                            defaultValue = session.User.EMAIL;
                            break;
                        case FONCTION_WORKFLOW_COMPONENT.DATE_EXECUTION_WORKFLOW:
                            const dateFormat = (_component as any).DATE_FORMAT ?? "YYYY-MM-DD HH:mm:ss";
                            defaultValue = moment().format(dateFormat);
                            break;
                        case FONCTION_WORKFLOW_COMPONENT.ROW_INDEX:
                            defaultValue = 1;
                            break;
                        case FONCTION_WORKFLOW_COMPONENT.GUID:
                            defaultValue = Guid.create().toString();
                            break;
                    }
                }
                break;
        
            case TYPE_DEFAULT_VALUE.CONSTANT: 
            default:
            defaultValue = _component.RESPONSE_VALUE || _component.DEFAULT_VALUE;
            break;
        }

        if (_options.COMPONENTS_MODE == COMPONENT_MODE.EXECUTION && (_component.HAS_DATASOURCE === true && !!_component.NUM_DATASOURCE && !!_component.NUM_DATASOURCE.NUM_DATASOURCE && !!_component.NUM_DATASOURCE.DS_FILTERS)) {
            _component.NUM_DATASOURCE.DS_FILTERS.forEach(_filter => {
                if ((_filter.TYPE_DEFAULT_VALUE == TYPE_DEFAULT_VALUE.WORKFLOW_FIELD && _options.isGridComponent != true) || (_options.isGridComponent === true && _filter.TYPE_DEFAULT_VALUE == TYPE_DEFAULT_VALUE.WORKFLOW_GRID_FIELD)) {
                    _component.UIC_PARAMS.OBSERVERS.push({ field: _filter.DEFAULT_VALUE, type: TYPE_WORKFLOW_COMPONENT_OBSERVER.FILTER_DATASOURCE, params: _filter.DATASOURCE_COLUMN, formId: _options.isGridComponent == true && !!_options.gridFormId ? _options.gridFormId : _options.formId });
                }
            });
        }

        _component.DEFAULT_VALUE = defaultValue;

        const gridContext = this.context;
        if (!gridContext.formValues) { gridContext.formValues = {}; }
        if (!context.formValues[formId]) { context.formValues[formId] = {}; }
        context.formValues[formId][_component.ID] = defaultValue;
        this.workflowValuesChanged$.next(context);

        return _component;
    }

    private async _processComponent(_component: Model_WorkflowComponent, _options: WorkflowComponentBuilderOptions, _basedComponents: Model_WorkflowComponent[]) {
        _component.COMPONENT_MODE = _options.COMPONENTS_MODE;
        _component = this._processComponentDefaultValue(_component, _options);
        _component.IS_REQUIRED = !_component.IS_REQUIRED !== undefined ? _component.IS_REQUIRED : false;
        _component.IS_VISIBLE = _component.IS_VISIBLE !== undefined && _component.COMPONENT_MODE == COMPONENT_MODE.EXECUTION ? _component.IS_VISIBLE : true;
        _component.IS_READONLY = _component.IS_READONLY;

        // #region BUILD COMPONENT DATASOURCES
        const basedComponent = _basedComponents.find(c => c.CODE == _component.CODE);
        if (!!_component.UIC_PARAMS && !!_component.UIC_PARAMS.DATASOURCE && !_component.UIC_PARAMS.DATASOURCE.DATASOURCE_FILTERED_DATAS) {
            _component.UIC_PARAMS.DATASOURCE.DATASOURCE_FILTERED_DATAS = _component.UIC_PARAMS.DATASOURCE.DATASOURCE_DATAS;
        }
        if (basedComponent !== undefined && _component.HAS_DATASOURCE === true) {
            if (!_component.UIC_PARAMS) {  _component.UIC_PARAMS = {}; }
            if (!_component.UIC_PARAMS.OBSERVERS) { _component.UIC_PARAMS.OBSERVERS = []; }

            let datasourcesInfos = [
                { 
                    DS_PROP_ID: 'NUM_DATASOURCE', 
                    DS_PROP_VALUE_COLUMN_ID: 'VALUE_COLUMN_NAME', 
                    DS_PROP_DISPLAY_COLUMN_ID: 'DISPLAY_COLUMN_NAME', 
                    DS_BUILD_NAME: 'DATASOURCE' 
                }
            ];
            if (!!basedComponent.DATASOURCES_INFOS) {
                datasourcesInfos = basedComponent.DATASOURCES_INFOS;
            }
            for (var datasourceId in datasourcesInfos) {
                const datasourceInfos = datasourcesInfos[datasourceId];
                if (!_component.UIC_PARAMS[datasourcesInfos[datasourceId].DS_PROP_ID]) {
                    const datasourceObj = await this._doBuildComponentDatasource(_component, _options, datasourceInfos);
                    _component.UIC_PARAMS[datasourceInfos.DS_BUILD_NAME] = {
                        DATASOURCE_TYPE: datasourceObj.datasource.TYPE_DATASOURCE,
                        DATASOURCE_DATAS: datasourceObj.datas,
                        DATASOURCE_FILTERED_DATAS: datasourceObj.filteredDatas,
                        DATASOURCE_VALUE_FIELD: datasourceObj.DATASOURCE_VALUE_FIELD,
                        DATASOURCE_DISPLAY_FIELD: datasourceObj.DATASOURCE_DISPLAY_FIELD,
                        DATASOURCE_DS_FILTERS: datasourceObj.DATASOURCE_DS_FILTERS,
                        DATASOURCE_COLUMNS: datasourceObj.absColumns,
                        DATASOURCE_COUNT_TOTAL: datasourceObj.countTotal,
                        DATASOURCE_TOTAL_PAGES: datasourceObj.totalPages,
                        DATASOURCE_PAGE_NUMBER: datasourceObj.pageNumber,
                        DATASOURCE_PAGE_SIZE: datasourceObj.pageSize,
                    };
                    /*if (!!_component.NUM_DATASOURCE && !!_component.NUM_DATASOURCE.DS_FILTERS) {
                        _component.NUM_DATASOURCE.DS_FILTERS.forEach(_filter => {
                            if (_filter.TYPE_DEFAULT_VALUE == TYPE_DEFAULT_VALUE.WORKFLOW_FIELD) {
                                _component.UIC_PARAMS.OBSERVERS.push({ field: _filter.DEFAULT_VALUE, type: TYPE_WORKFLOW_COMPONENT_OBSERVER.FILTER_DATASOURCE, params: _filter.DATASOURCE_COLUMN });
                            }
                        });
                    }*/
                }
            }
        }
        // #endregion

        // #region BUILD COMPONENT RELATIONS
        _component.RELATIONS = _component.RELATIONS !== undefined ? _component.RELATIONS : [];
        // #endregion
        
        const customValidators: any = {};
        if (!!_component.CUSTOM_VALIDATORS) {
            _component.CUSTOM_VALIDATORS.forEach(_validator => {
                customValidators[_validator.VALIDATOR_NAME] = { name: _validator.VALIDATOR_NAME, args: null }
            });
        }
        _component.CUSTOM_VALIDATORS = customValidators;

        return _component;
    }
    // #endregion
    
    doBuildWorkflowModel(_components: Model_WorkflowComponent[], _options: WorkflowComponentBuilderOptions) {
        return new Promise<DynamicFormControlModel[]>(async (resolve, reject) => {
            const formModels: DynamicFormControlModel[] = [];
            const basedComponents = await this.doGetBaseWorkflowComponents(_options).toPromise();
            const clonedComponents = JSON.parse(JSON.stringify(_components));
            const formGroupId = _options.formId || uuidv4();
            for (var comp in clonedComponents) {
                clonedComponents[comp].FORM_ID = formGroupId;
                const component = await this._processComponent(clonedComponents[comp], _options, basedComponents);
                component.FORM_ID = formGroupId;
                let formModel: DynamicFormControlModel;
                switch(component.CODE) {
                    case CODE_WORKFLOW_COMPONENT.LABEL:
                        formModel = LabelModel.initModel(component); 
                        formModels.push(formModel);
                        break;

                    case CODE_WORKFLOW_COMPONENT.TEXTBOX:
                        formModel = TextboxModel.initModel(component); 
                        formModels.push(formModel);
                        break;

                    case CODE_WORKFLOW_COMPONENT.NUMERIC_TEXTBOX:
                        formModel = NumericTextboxModel.initModel(component);
                        formModels.push(formModel);
                        break;

                    case CODE_WORKFLOW_COMPONENT.DROPDOWN:
                        formModel = DropdownModel.initModel(component, component.UIC_PARAMS.DATASOURCE);
                        formModels.push(formModel);
                        break;

                    case CODE_WORKFLOW_COMPONENT.TOGGLE:
                        formModel = ToggleModel.initModel(component);
                        formModels.push(formModel);
                        break;

                    case CODE_WORKFLOW_COMPONENT.TEXTAREA:
                        formModel = TextareaModel.initModel(component);
                        formModels.push(formModel);
                        break;

                    case CODE_WORKFLOW_COMPONENT.DATEPICKER:
                        formModel = DatePickerModel.initModel(component);
                        formModels.push(formModel);
                        break;

                    case CODE_WORKFLOW_COMPONENT.DATASOURCE_PICKER:
                        const workflowComponentsDatasourcePicker = !!_options && !!_options.workflow ? Array.prototype.concat.apply([], _options.workflow.WORKFLOW_STEPS.filter(step => !!step.COMPONENTS).map(step => step.COMPONENTS.map(component => component))) : [];
                        const datasourcePickerOptions: Model_WorkflowDatasourcePickerComponent = Object.assign({
                            workflowComponents: workflowComponentsDatasourcePicker,
                            variablesEnvironnement: _options.variablesEnvironnement
                        }, component);
                        formModel = DatasourcePickerModel.initModel(datasourcePickerOptions);
                        formModels.push(formModel);
                        break;

                    case CODE_WORKFLOW_COMPONENT.CHECKBOX:
                        formModel = CheckboxModel.initModel(component, component.UIC_PARAMS.DATASOURCE);
                        formModels.push(formModel);
                        break;

                    case CODE_WORKFLOW_COMPONENT.RADIOBOX:
                        formModel = RadioboxModel.initModel(component, component.UIC_PARAMS.DATASOURCE);
                        formModels.push(formModel);
                        break;

                    case CODE_WORKFLOW_COMPONENT.ELECTRONIC_SIGNATURE:
                        formModel = ElectronicSignatureModel.initModel(component);
                        formModels.push(formModel);
                        break;

                    case CODE_WORKFLOW_COMPONENT.SCAN_QRCODE:
                        formModel = CodeScannerModel.initModel(component);
                        formModels.push(formModel);
                        break;

                    case CODE_WORKFLOW_COMPONENT.SCAN_DOCUMENT:
                        formModel = DocumentScannerModel.initModel(component);
                        formModels.push(formModel);
                        break;

                    case CODE_WORKFLOW_COMPONENT.UPLOAD_FILE:
                        formModel = UploadFileModel.initModel(component);
                        formModels.push(formModel);
                        break;

                    case CODE_WORKFLOW_COMPONENT.CAMERA:
                        formModel = CameraModel.initModel(component);
                        formModels.push(formModel);
                        break;

                    case CODE_WORKFLOW_COMPONENT.INPUT_GRID:
                        formModel = InputGridModel.initModel(component, _options);
                        formModels.push(formModel);
                        break;

                    case CODE_WORKFLOW_COMPONENT.INPUT_GRID_COLUMNS_BUILDER:
                        const inputGridColumnsBuilderComponent: Model_InputGridColumnsBuilderComponent = Object.assign({
                            workflowComponents: !!_options && !!_options.workflow ? Array.prototype.concat.apply([], _options.workflow.WORKFLOW_STEPS.filter(step => !!step.COMPONENTS).map(step => step.COMPONENTS.map(component => component))) : [],
                            variablesEnvironnement: _options.variablesEnvironnement
                        }, component);
                        formModel = InputGridColumnsBuilderModel.initModel(inputGridColumnsBuilderComponent);
                        formModels.push(formModel);
                        break;

                    case CODE_WORKFLOW_COMPONENT.INPUT_GRID_COLUMNS_DATASOURCE_MAPPING:
                        formModel = InputGridColumnsDatasourceMappingModel.initModel(component);
                        formModels.push(formModel);
                        break;

                    case CODE_WORKFLOW_COMPONENT.FAMOCO_SCAN_LASER:
                        formModel = FamocoScanLaserModel.initModel(component);
                        formModels.push(formModel);
                        break;

                    case CODE_WORKFLOW_COMPONENT.RICH_AUTOCOMPLETE:
                        const workflowComponents = !!_options && !!_options.workflow ? Array.prototype.concat.apply([], _options.workflow.WORKFLOW_STEPS.filter(step => !!step.COMPONENTS).map(step => step.COMPONENTS.map(component => component))) : [];
                        const autocompleteOptions: Model_WorkflowRichAutoCompleteComponent = Object.assign({
                            workflowComponents: workflowComponents,
                            variablesEnvironnement: _options.variablesEnvironnement
                        }, component);
                        
                        formModel = RichAutocompleteModel.initModel(autocompleteOptions);
                        formModels.push(formModel);
                        break;

                    case CODE_WORKFLOW_COMPONENT.GED:
                        formModel = GedModel.initModel(component);
                        formModels.push(formModel);
                        break;

                    case CODE_WORKFLOW_COMPONENT.GED_DESIGNER:
                        formModel = GedDesignerModel.initModel(component);
                        formModels.push(formModel);
                        break;

                    case CODE_WORKFLOW_COMPONENT.SOUDOTEC_BARCODES_VERIFICATION:
                        formModel = BarcodesVerificationModel.initModel(component);
                        formModels.push(formModel);
                        break;

                    case CODE_WORKFLOW_COMPONENT.SOUDOTEC_COMMAND_GRIDINPUT:
                        formModel = CommandGridInputModel.initModel(component);
                        formModels.push(formModel);
                        break;

                    case CODE_WORKFLOW_COMPONENT.SOUDOTEC_INVENTORY_INPUT:
                        formModel = InventoryInputModel.initModel(component);
                        formModels.push(formModel);
                        break;

                    case CODE_WORKFLOW_COMPONENT.MIBEM_COMMAND_INPUT:
                        formModel = MibemCommandInputModel.initModel(component);
                        formModels.push(formModel);
                        break;

                    case CODE_WORKFLOW_COMPONENT.EXPRESSION_EVALUATOR:
                        formModel = ExpressionEvaluatorModel.initModel(component);
                        formModels.push(formModel);
                        break;

                    case CODE_WORKFLOW_COMPONENT.DATASOURCE_DATAS_SELECTION:
                        formModel = DatasourceDatasSelectionModel.initModel(component, component.UIC_PARAMS.DATASOURCE);
                        formModels.push(formModel);
                        break;

                    case CODE_WORKFLOW_COMPONENT.INPUT_GRID_FUNCTIONS:
                        formModel = InputGridFunctionsModel.initModel(component);
                        formModels.push(formModel);
                        break;

                    case CODE_WORKFLOW_COMPONENT.INPUT_GRID_FILTERS:
                        formModel = InputGridFunctionsFiltersModel.initModel(component);
                        formModels.push(formModel);
                        break;

                    case CODE_WORKFLOW_COMPONENT.SOUDOTEC_RECEPTION_MARCHANDISE:
                        formModel = ReceptionMarchandiseModel.initModel(component);
                        formModels.push(formModel);
                        break;

                    case CODE_WORKFLOW_COMPONENT.NEWLAND_SCANNER:
                        formModel = NewlandScannerModel.initModel(component);
                        formModels.push(formModel);
                        break;

                    case CODE_WORKFLOW_COMPONENT.BE_RETAIL_INVENTORY_INPUT:
                        formModel = BERetailInventoryInputModel.initModel(component);
                        formModels.push(formModel);
                        break;

                    case CODE_WORKFLOW_COMPONENT.AGENDA_PLANNER:
                        formModel = AgendaPlannerModel.initModel(component);
                        formModels.push(formModel);
                        break;

                    case CODE_WORKFLOW_COMPONENT.BLACK_HAWK_SCAN_QRCODE:
                        formModel = BHQrCodeScannerModel.initModel(component);
                        formModels.push(formModel);
                        break;

                    case CODE_WORKFLOW_COMPONENT.BLACK_HAWK_SCAN_QRCODE_SITE:
                        formModel = BHQrCodeSiteScannerModel.initModel(component);
                        formModels.push(formModel);
                        break;

                    case CODE_WORKFLOW_COMPONENT.MULTIPACK_COMMERCIAL_PLANNING:
                        formModel = MultipackCommercialPlanningModel.initModel(component);
                        formModels.push(formModel);
                        break;

                    case CODE_WORKFLOW_COMPONENT.MULTIPACK_COMMERCIAL_PLANNING:
                        formModel = MultipackCommercialPlanningModel.initModel(component);
                        formModels.push(formModel);
                        break;

                    case CODE_WORKFLOW_COMPONENT.KANBAN:
                        formModel = KanbanModel.initModel(component, _options);
                        formModels.push(formModel);
                        break;

                    case CODE_WORKFLOW_COMPONENT.SOUDOTEC_ITEMS_INPUT:
                        formModel = SoudotecItemsInputModel.initModel(component);
                        formModels.push(formModel);
                        break;

                    case CODE_WORKFLOW_COMPONENT.SOUDOTEC_EMPLACEMENT_INPUT:
                        formModel = SoudotecEmplacementInputModel.initModel(component);
                        formModels.push(formModel);
                        break;
                }
            }

            resolve(formModels);
        });
    }

    doBuildWorkflowFormGroup(_formModels: DynamicFormControlModel[]) {
        return this.formService.createFormGroup(_formModels);
    }

    async doFindBaseWorkflowComponent(_codeComponent: CODE_WORKFLOW_COMPONENT) {
        const workflowComponents = await this.doGetBaseWorkflowComponents().toPromise();
        return workflowComponents.find(component => component.CODE == _codeComponent);
    }

    doGetBaseWorkflowComponents(_options?: WorkflowComponentBuilderOptions) {
        return of<Model_WorkflowComponent[]>([
            LabelModel.getProperties(_options),
            TextboxModel.getProperties(_options),
            NumericTextboxModel.getProperties(_options),
            TextareaModel.getProperties(_options),
            DatePickerModel.getProperties(_options),
            DropdownModel.getProperties(_options),
            CheckboxModel.getProperties(_options),
            RadioboxModel.getProperties(_options),
            ElectronicSignatureModel.getProperties(_options),
            CodeScannerModel.getProperties(_options),
            DocumentScannerModel.getProperties(_options),
            UploadFileModel.getProperties(_options),
            CameraModel.getProperties(_options),
            InputGridModel.getProperties(_options),
            InputGridFunctionsModel.getProperties(_options),
            FamocoScanLaserModel.getProperties(_options),
            BarcodesVerificationModel.getProperties(_options),
            CommandGridInputModel.getProperties(_options),
            InventoryInputModel.getProperties(_options),
            ReceptionMarchandiseModel.getProperties(_options),
            MibemCommandInputModel.getProperties(_options),
            ExpressionEvaluatorModel.getProperties(_options),
            DatasourceDatasSelectionModel.getProperties(_options), 
            BERetailInventoryInputModel.getProperties(_options),
            AgendaPlannerModel.getProperties(_options),
            BHQrCodeScannerModel.getProperties(_options),
            BHQrCodeSiteScannerModel.getProperties(_options),
            MultipackCommercialPlanningModel.getProperties(_options),
            KanbanModel.getProperties(_options),
            SoudotecItemsInputModel.getProperties(_options),
            SoudotecEmplacementInputModel.getProperties(_options),
        ]);
    }

    doEvaluateExecutionExpression(_expression: string, _params: { components: Model_WorkflowComponent[], componentsValues: {[key: string]: any}, variables: Model_VariableEnvironnementUser[], fonctionsIds: { ID: string, TEXT: string }[], type?: 'text'|'html' }) {
        let regex = /\@\[([\w]+)\]/g;
        let computedControls = _expression.match(regex);
        if (!!computedControls) {
            computedControls.map(matched => matched.substr(2, matched.length - 3)).forEach((field) => {
                const matchedComponent = _params.components.find(c => c.ID == field);
                let matchedComponentValue = _params.componentsValues[field];
                if (matchedComponent.CODE == CODE_WORKFLOW_COMPONENT.NUMERIC_TEXTBOX) {
                    try {
                        matchedComponentValue = new Intl.NumberFormat('fr-FR', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        }).format(matchedComponentValue);
                    } catch(e) {}
                } else if (matchedComponent.CODE == CODE_WORKFLOW_COMPONENT.BLACK_HAWK_SCAN_QRCODE) {
                    matchedComponentValue = `${matchedComponentValue.NOM_SITE} / ${matchedComponentValue.DATE_CONTROLE} / ${matchedComponentValue.TOTAL_PRESENCES} agent(s) présent(s)`;
                } else if (matchedComponent.CODE == CODE_WORKFLOW_COMPONENT.BLACK_HAWK_SCAN_QRCODE_SITE) {
                    matchedComponentValue = `${matchedComponentValue.NOM_SITE} / ${matchedComponentValue.DATE_CONTROLE} / ${matchedComponentValue.TOTAL_PRESENCES} agent(s) présent(s)`;
                }
                if (!!matchedComponent && matchedComponentValue !== undefined) {
                    if (!!_params.type && _params.type == 'html') {
                        switch(matchedComponent.CODE) {
                            case CODE_WORKFLOW_COMPONENT.ELECTRONIC_SIGNATURE:
                                _expression = _expression.replace(new RegExp('\\@\\[' + field + '\\]', 'g'), `<img src="data:image/png;base64,${matchedComponentValue}" />`);
                                break;
    
                            default:
                                _expression = _expression.replace(new RegExp('\\@\\[' + field + '\\]', 'g'), matchedComponentValue);
                                break;
                        }
                    } else {
                        _expression = _expression.replace(new RegExp('\\@\\[' + field + '\\]', 'g'), matchedComponentValue);
                    }
                } else {
                    _expression = _expression.replace(new RegExp('\\@\\[' + field + '\\]', 'g'), '');
                }
            });
        }
        regex = /\#\[([\w]+)\]/g;
        computedControls = _expression.match(regex);
        if (!!computedControls) {
            computedControls.map(matched => matched.substr(2, matched.length - 3)).forEach((field) => {
                const matchedVariable = _params.variables.find(v => v.NOM_VARIABLE == field);
                if (!!matchedVariable) {
                    _expression = _expression.replace(new RegExp('\\#\\[' + field + '\\]', 'g'), matchedVariable.VALEUR_VARIABLE);
                } else {
                    const matchedFunction = _params.fonctionsIds.find(v => v.ID == field);
                    if (!!matchedFunction) {
                        const fonctionId = matchedFunction.ID as FONCTION_WORKFLOW_COMPONENT;
                        let columnValue = '';
                        if (fonctionId == FONCTION_WORKFLOW_COMPONENT.ROW_INDEX) {
                            columnValue = '1';
                        } else if (fonctionId == FONCTION_WORKFLOW_COMPONENT.GUID) {
                            columnValue = Guid.create().toString();
                        } else if (fonctionId == FONCTION_WORKFLOW_COMPONENT.ID_AGENT) {
                            columnValue = this._authService.AuthSession.User.ID;
                        } else if (fonctionId == FONCTION_WORKFLOW_COMPONENT.NOM_AGENT) {
                            columnValue = this._authService.AuthSession.User.NOM;
                        } else if (fonctionId == FONCTION_WORKFLOW_COMPONENT.PRENOMS_AGENT) {
                            columnValue = this._authService.AuthSession.User.PRENOM;
                        } else if (fonctionId == FONCTION_WORKFLOW_COMPONENT.EMAIL_AGENT) {
                            columnValue = this._authService.AuthSession.User.EMAIL;
                        } else if (fonctionId == FONCTION_WORKFLOW_COMPONENT.USERNAME_AGENT) {
                            columnValue = this._authService.AuthSession.User.USERNAME;
                        } else if (fonctionId == FONCTION_WORKFLOW_COMPONENT.DATE_EXECUTION_WORKFLOW) {
                            const dateDebutWorkflow = moment().format('DD/MM/YYYY HH:mm:ss');
                            columnValue = dateDebutWorkflow;
                        }
                        _expression = _expression.replace(new RegExp('\\#\\[' + field + '\\]', 'g'), columnValue);
                    } else {
                        _expression = _expression.replace(new RegExp('\\#\\[' + field + '\\]', 'g'), '');
                    }
                }
            });
        }
        return _expression;
    }
}